export const SET_STATE = 'SET_STATE'
export const RESET_STATE = 'RESET_STATE'
export const CLEAN_STATE = 'CLEAN_STATE'

export const SET_SCREEN = 'SET_SCREEN'
export const SET_SCREEN_DATA = 'SET_SCREEN_DATA'
